import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {imgUrl} from '-/api/api';
import {hasFullTheme} from '-/styles/utils';

const styles = {
    root: {
        verticalAlign: 'middle'
    },
    responsive: {
        minWidth: '100%',
        width: '100%',
        height: 'auto'
    }
};

class HeaderImage extends Component {
    render() {
        const {name, offerId, creditorId, classes = {}} = this.props;
        const imgStyles = classNames(classes.root, classes.responsive);
        // only return header image if we have a full theme; otherwise, our image request will fail
        // TODO: Should probably have a default image/theme that comes back from service so that this doesn't fail
        return hasFullTheme() ? <img src={imgUrl(name, offerId, creditorId)} alt="Banner" className={imgStyles} /> : null;
    }
}

export default injectSheet(styles)(HeaderImage);
